var scope_0 = require('C:/Users/iymmo/Source/Repos/orj-YMMO-Akademik/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('C:/Users/iymmo/Source/Repos/orj-YMMO-Akademik/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ebd81c2f10a8123197672388a4fda6f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    